import { render, staticRenderFns } from "./RevenueByCategoryPage.vue?vue&type=template&id=b17700a8&scoped=true"
import script from "./RevenueByCategoryPage.vue?vue&type=script&lang=js"
export * from "./RevenueByCategoryPage.vue?vue&type=script&lang=js"
import style0 from "./RevenueByCategoryPage.vue?vue&type=style&index=0&id=b17700a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17700a8",
  null
  
)

export default component.exports